import React from 'react';
import { Button, Card, Col, Container, Row, Badge } from 'react-bootstrap';
import { FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';

const LeadDashboard = () => {
  const webinars = [
    {
      title: 'Cloud computing and New AI technologies.',
      date: '05 June 2025 at 09:30 PM IST',
      daysLeft: '6 more days left'
    },
    {
      title: 'Learn How to Grow your Business',
      date: '15 June 2025 at 09:30 PM IST',
      daysLeft: '15 more days left'
    }
  ];

  const burntOrange = '#CC5500';
  const lightCardBg = '#FFF9F4';

  const pricingPlans = [
    {
      title: 'Basic Plan',
      term: '6 months',
      cost: '₹10,000 + Tax',
      features: [
        'Use 20+ templates',
        'Post in social media',
        'Track and manage leads',
        'WhatsApp & email follow-ups',
        'Automated reminders'
      ]
    },
    {
      title: 'Premium Plan',
      term: '12 months',
      cost: '₹30,000 + Tax',
      features: [
        'Use 50+ templates',
        'Post in social media',
        'Track and manage leads',
        'WhatsApp & email follow-ups',
        'Automated reminders'
      ]
    },
    {
      title: 'Premium Plan + AI',
      term: '12 months',
      cost: '₹40,000 + Tax',
      features: [
        'Everything in Premium',
        'Create fully customized AI campaigns',
        'Generate AI images (up to 10/mo)'
      ]
    }
  ];

  return (
    <Container className="py-4">
      <Card className="mb-4 border-0 shadow-sm" style={{ backgroundColor: lightCardBg }}>
        <Card.Body>
          <h5 style={{ color: burntOrange }}>🎉 Welcome to Nurturix!</h5>
          <p className="mb-2">You're now one step closer to growing your business 🚀</p>
          <ul className="mb-3 ps-3">
            <li>✅ Create campaigns using customizable templates</li>
            <li>✅ Access your portal with drag-and-drop dashboard</li>
            <li>✅ Schedule follow-ups via WhatsApp & email</li>
            <li>✅ Track leads & analyze performance</li>
            <li>✅ Use a professional dashboard tailored to you</li>
          </ul>
          <p className="mb-1">
            🔓 <strong><a href="#">Activate My Account</a></strong> — You're covered with a 30-day money-back guarantee.
          </p>
        </Card.Body>
      </Card>

      <h6 className="fw-bold text-uppercase mb-3" style={{ color: burntOrange }}>📅 Upcoming Webinars</h6>
      <Row className="g-3 mb-4">
        {webinars.map((webinar, idx) => (
          <Col md={6} key={idx}>
            <Card className="border-light shadow-sm h-100">
              <Card.Body>
                <h6 className="fw-semibold mb-1">{webinar.title}</h6>
                <small className="text-muted"><FaCalendarAlt className="me-1" />{webinar.date}</small>
                <div className="mt-2">
                  <Badge bg="warning" text="dark">{webinar.daysLeft}</Badge>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <h6 className="fw-bold text-uppercase mb-3" style={{ color: burntOrange }}>💼 Pricing Plans</h6>
      <Row className="g-3">
        {pricingPlans.map((plan, index) => (
          <Col md={4} key={index}>
            <Card className="h-100 border-0 shadow-sm" style={{ backgroundColor: lightCardBg }}>
              <Card.Header className="text-white fw-bold text-center" style={{ backgroundColor: burntOrange }}>
                {plan.title}
              </Card.Header>
              <Card.Body className="d-flex flex-column">
                <div className="mb-2">
                  <strong>Term:</strong> {plan.term}<br />
                  <strong>Cost:</strong> {plan.cost}
                </div>
                <hr />
                <p className="fw-semibold mb-1">Included:</p>
                <ul className="text-start small ps-3 mb-4">
                  {plan.features.map((feature, i) => (
                    <li key={i}><FaCheckCircle className="text-success me-1" />{feature}</li>
                  ))}
                </ul>
                <div className="mt-auto">
                  <Button variant="outline-dark" style={{ borderColor: burntOrange, color: burntOrange }}>
                    Activate
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default LeadDashboard;
